import { createApp } from 'vue';
import App from './App.vue';
import { pwa } from './config';
import { setupVab } from '~/library';
import { setupI18n } from '@/i18n';
import { setupStore } from '@/store';
import { setupRouter } from '@/router';
// 全局拦截 ResizeObserver loop 无害警告（Element Plus 组件常见）
const _resizeObserverErr = window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
        e.stopImmediatePropagation();
        e.stopPropagation();
        e.preventDefault();
        return true;
    }
});
// 捕获 unhandledrejection 中的同类警告
window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes?.('ResizeObserver loop')) {
        e.preventDefault();
    }
});
// 商业授权校验已移除：本项目使用 vab 模板，授权由项目方与模板方另行约定
// validateSecretKey() // 注释掉：避免生产环境清空 DOM
const app = createApp(App);
// 生产环境 mockXHR 已禁用：所有请求直接走真实后端 /api/admin/v1
// if (process.env.NODE_ENV === 'production' && !isExternal(baseURL)) {
//     const { mockXHR } = require('@/utils/static')
//     mockXHR()
// }
/**
 * @description 生产环境启用组件初始化，编译，渲染和补丁性能跟踪。仅在开发模式和支持 Performance.mark API的浏览器中工作。
 */
//if (process.env.NODE_ENV === 'development') app.config.performance = true
if (pwa)
    require('./registerServiceWorker');
setupVab(app);
setupI18n(app);
setupStore(app);
setupRouter(app)
    .isReady()
    .then(() => app.mount('#app'));
